import { render } from "./formlisting.vue?vue&type=template&id=5d8e7e86&scoped=true"
import script from "./formComponent.js?vue&type=script&lang=js"
export * from "./formComponent.js?vue&type=script&lang=js"

import "./formlisting.vue?vue&type=style&index=0&id=5d8e7e86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8e7e86"]])

export default __exports__